module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_7005.619fe914.png";